module.exports = __webpack_public_path__ + "img/3.144a603f.png";